export const FILE = 'file';
export const UPLOADING = 'uploading';
export const PROGRESS = 'progress';
export const DROP = 'drop';
export const DIALOG = 'dialog';
export const OVERWRITE = 'overwrite';
export const MODULE_NAME = 'upload';

export const TEMP_INPUT = 'tempInput';
